import { DataAccess } from "../dataaccess/data.access";
import { SpecialDateRow, SpecialDatesListResponse } from "../pojo/SpecialDate";
import { S25Util } from "../util/s25-util";

function normalizeSpecialDateRow(row: SpecialDateRow & Record<string, unknown>): SpecialDateRow {
    const startRaw = (row.startDate ?? row.start_date) as string | undefined;
    const endRaw = (row.endDate ?? row.end_date) as string | undefined;
    return {
        specialDateId: row.specialDateId ?? (row.special_date_id as number | undefined),
        seedKey: row.seedKey ?? (row.seed_key as string | undefined),
        name: row.name,
        categoryCode: row.categoryCode ?? (row.category_code as string),
        startDate: startRaw ?? "",
        endDate: endRaw ?? "",
        showOnCalendar: row.showOnCalendar ?? (row.show_on_calendar as boolean | undefined),
        isDelete: row.isDelete ?? (row.is_delete as boolean | undefined),
    };
}

export class SpecialDateService {
    public static list(params?: {
        startDate?: string;
        endDate?: string;
        includeDeleted?: boolean;
    }): Promise<SpecialDatesListResponse> {
        let url = DataAccess.injectCaller("/special/dates/list.json", "SpecialDateService.list");
        if (params?.startDate) {
            url = S25Util.addParam(url, "start_date", params.startDate);
        }
        if (params?.endDate) {
            url = S25Util.addParam(url, "end_date", params.endDate);
        }
        if (params?.includeDeleted) {
            url = S25Util.addParam(url, "include_deleted", "true");
        }
        return DataAccess.get(url).then((body: SpecialDatesListResponse & Record<string, unknown>) => ({
            dates: (body?.dates ?? []).map(normalizeSpecialDateRow),
            featureEnabled: body?.featureEnabled ?? (body?.feature_enabled as boolean | undefined),
        }));
    }

    public static save(row: SpecialDateRow): Promise<SpecialDateRow> {
        return DataAccess.post(
            DataAccess.injectCaller("/special/dates/save.json", "SpecialDateService.save"),
            row,
        ).then((response: { upsertData?: SpecialDateRow }) => response?.upsertData ?? row);
    }

    public static delete(specialDateId: number): Promise<void> {
        return DataAccess.delete(
            DataAccess.injectCaller(
                `/special/dates/delete.json?special_date_id=${specialDateId}`,
                "SpecialDateService.delete",
            ),
        );
    }
}
